// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap___LAJP","form":"styles_form__3XqEP","item":"styles_item__2R5bR","button":"styles_button__36wRB","error":"styles_error__2Xh34"};